import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ComplainPriority,
  ComplainStatus,
  ComplainTypes,
} from "../types/complaintTypes";

export type ComplaintFilterValues = {
  status?: ComplainStatus | "";
  priority?: ComplainPriority | "";
  type?: ComplainTypes | "";
};

type ComplaintFiltersProps = {
  filters: ComplaintFilterValues;
  onChange: (filters: ComplaintFilterValues) => void;
};

export const ComplaintFilters = ({
  filters,
  onChange,
}: ComplaintFiltersProps) => {
  const { t } = useTranslation();
  const { t: te } = useTranslation("enums");

  const handleSelect =
    (field: keyof ComplaintFilterValues) => (event: SelectChangeEvent) => {
      onChange({ ...filters, [field]: event.target.value });
    };

  return (
    <Grid container spacing={2} sx={{ mt: 0.5, mb: 1 }}>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth size="small">
          <InputLabel>{t("status")}</InputLabel>
          <Select
            label={t("status")}
            value={filters.status ?? ""}
            onChange={handleSelect("status")}
          >
            <MenuItem value="">{t("all")}</MenuItem>
            {Object.values(ComplainStatus).map((s) => (
              <MenuItem key={s} value={s}>
                {te(s)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth size="small">
          <InputLabel>{t("priority")}</InputLabel>
          <Select
            label={t("priority")}
            value={filters.priority ?? ""}
            onChange={handleSelect("priority")}
          >
            <MenuItem value="">{t("all")}</MenuItem>
            {Object.values(ComplainPriority).map((p) => (
              <MenuItem key={p} value={p}>
                {te(p)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth size="small">
          <InputLabel>{t("type")}</InputLabel>
          <Select
            label={t("type")}
            value={filters.type ?? ""}
            onChange={handleSelect("type")}
          >
            <MenuItem value="">{t("all")}</MenuItem>
            {Object.values(ComplainTypes).map((ty) => (
              <MenuItem key={ty} value={ty}>
                {te(ty)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};
